import instagram from "../../assets/img/icon-instagram.png";
import facebook from "../../assets/img/icon-facebook.png";
import youtube from "../../assets/img/icon-youtube.svg";
import telegram from "../../assets/img/icon-telegram.png";
import soudcloud from "../../assets/img/icon-soundcloud.png";
import linkedin from "../../assets/img/icon-linkedin.png";
import logoGreat from "../../assets/img/selo-gptw 2024.png";
import logoPrevic from "../../assets/img/logo_Previc.png";
import logoForluz from "../../assets/img/logo-forluz-laranja.svg";
import bureau from "../../assets/img/bureau.png";
import cemig from "../../assets/img/cemig.png";
import cemigsaude from "../../assets/img/logo_cemig_saude.png";
import gasmig from "../../assets/img/gasmig.png";
import taesa from "../../assets/img/taesa.png";
import indi from "../../assets/img/invest_minas-1.png";
import efficientia from "../../assets/img/efficientia.png";
import '../../assets/files/Certificado.pdf';

const Footer = (props: any) => {

  return (
    <>
      <footer
        style={{ position: "inherit", left: 0, bottom: 0, right: 0 }}
        className="footer bg-light px-4"
      >
        <div className="container-fluid py-7">
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="footer__logo-forluz">
                <img src={logoForluz} alt="Logo" />
              </div>

              <div className="footer__desc mt-5">
                <p className="mb-2">
                  {" "}
                  Forluz - Fundação Forluminas de Seguridade Social
                  <span className="footer-size"></span>
                  {/* <p className="mb-2">   </p> */}
                  Avenida do Contorno, 6500, 3° Andar - Lourdes CEP 30110-044
                  <span className="footer-size"></span>
                  {/* <p className="mb-2">   </p> */}
                  Belo Horizonte - MG{" "}
                </p>
                <p>
                  {" "}
                  <strong> 0800 - 090 9090 </strong>{" "}
                </p>
              </div>

              <div className="footer__midias pr-10 my-5">
                <ul className="list-unstyled d-flex align-items-center">
                  <li>
                    <a href="https://www.instagram.com/forluz_oficial/">
                      <img src={instagram} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href=" https://www.facebook.com/forluz.org/">
                      <img src={facebook} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/user/comunicacaoforluz">
                      <img src={youtube} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://t.me/+rVpfSec-JERhOTIx">
                      <img src={telegram} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://soundcloud.com/forluz">
                      <img src={soudcloud} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/forluz">
                      <img src={linkedin} alt="Icone" />
                    </a>
                  </li>
                </ul>
              </div>

              <a
                href="../Contato/fale-conosco"
                className="btn btn-primary py-4 px-5 rounded"
              >
                {" "}
                Fale com a Forluz{" "}
              </a>
            </div>

            <div className="col-md-6 col-lg-2 text-center my-lg-0">
              <div className="d-none d-lg-block">
                {/* <a href="#"> */}
                <img src={logoGreat} alt="" />
                {/* </a> */}
              </div>
            </div>

            <div className="col-lg-5 offset-lg-1">
              <div className="footer__parceiros pb-8 d-none d-lg-block">
                <div className="d-flex align-items-center justify-content-around justify-content-lg-start">
                  <a href="https://www.gov.br/previc/pt-br">
                    <img src={logoPrevic} alt="Logo" />
                  </a>
                  <a href="/docs/certificados/Certificado - Sistema de Gestão de Riscos.pdf" target="_blank">
                    <img src={bureau} alt="Logo" className="ml-lg-8" />
                  </a>
                </div>
              </div>

              <div className="footer__clientes pt-8 d-none d-lg-block">
                <div className="d-flex align-items-center flex-wrap">
                  <a href="https://www.cemig.com.br/" target="_blank" rel="noreferrer">
                    <img
                      src={cemig}
                      alt="Logo"
                      width="65"
                      className="mx-2 mb-3 mb-xl-0"
                    />
                  </a>

                  <a href="https://www.cemigsaude.org.br/site/home" target="_blank" rel="noreferrer">
                    <img
                      src={cemigsaude}
                      alt="Logo"
                      width="65"
                      className="mx-2 mb-3 mb-xl-0"
                    />
                  </a>

                  <a href="http://www.gasmig.com.br/" target="_blank" rel="noreferrer">
                    <img
                      src={gasmig}
                      alt="Logo"
                      width="65"
                      className="mx-2 mb-3 mb-xl-0"
                    />
                  </a>

                </div>
                <br></br>
                <div className="d-flex align-items-center flex-wrap">

                  <a rel="noreferrer" href="http://institucional.taesa.com.br/" target="_blank"
                  >
                    <img
                      src={taesa}
                      alt="Logo"
                      width="65"
                      className="mx-2 mb-3 mb-xl-0"
                    />
                  </a>
                  <a href="https://www.investminas.mg.gov.br/" target="_blank" rel="noreferrer">
                    <img
                      src={indi}
                      alt="Logo"
                      width="65"
                      className="mx-2 mb-3 mb-xl-0"
                    />
                  </a>
                  <a href="https://cemigsim.com.br/" target="_blank" rel="noreferrer">
                    <img
                      src={efficientia}
                      alt="Logo"
                      width="65"
                      className="mx-2 mb-3 mb-xl-0"
                    />
                  </a>
                </div>
              </div>
            </div>
            <p style={{ visibility: "hidden" }}>v.3.3.1</p>
          </div>
        </div>
      </footer>
    </>
  );

}

export default Footer;
